var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"experts"},_vm._l((_vm.data),function(item,index){return _c('Expert',{key:index,staticClass:"experts-item",attrs:{"data":item,"eduMap":_vm.eduMap}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }